import script from "./EditFlow.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditFlow.vue?vue&type=script&lang=ts&setup=true"

import "./EditFlow.vue?vue&type=style&index=0&id=4172669c&lang=scss"

const __exports__ = script;

export default __exports__